import bootstrap from './bootstrap';
import * as serviceWorker from './serviceWorker';

/** declare global definitions for window object */
declare global {
  interface Window {
    xprops: any;
  }
}

bootstrap(() => {});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
